module.exports = __webpack_public_path__ + "02754771/images/application.svg";